import templateUrl from './component.tpl.html';
import RsvpRelationsController from './controller';

angular
    .module('festzelt-os.guestlists')
    .component('rsvpRelations', {
        bindings: {
            rsvp: '<',
            guestlist: '<'
        },
        controller: RsvpRelationsController,
        controllerAs: 'vm',
        templateUrl: templateUrl
    });




// WEBPACK FOOTER //
// ./src/app/pages/guestlists/components/rsvp-relations/component.js